import { Component } from '@angular/core';

@Component({
    selector: 'app-account-activated',
    templateUrl: './account-activated.component.html',
    styleUrls: ['./account-activated.component.scss'],
    standalone: false
})
export class AccountActivatedComponent {

}
